import { useLanguageRegionCode } from '@alltrails/language/hooks/useLanguageRegionCode';
import useUser from '@alltrails/context/hooks/useUser';
import Button from '@alltrails/denali/components/Button';
import styles from './styles/styles.module.scss';

// English only - no translations exist for this component
export default function PlusCta() {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();

  if (languageRegionCode !== 'en-US') {
    return null;
  }

  return (
    <div className={styles.buttonContainer}>
      <Button
        text="Start your free trial"
        linkInfo={{
          href: user ? '/plus/checkout' : '/signup?returnTo=%2Fplus%2Fcheckout'
        }}
        testId="location-try-plus"
        variant="primary"
        width="fullOnMobile"
      />
    </div>
  );
}
